import { Auth } from "aws-amplify";
import React, { createContext } from "react";
import { Constants } from "../libs/Constants";
import { get } from "../libs/dbFunctions";
const initialState = {
  user: null,
  activeCompany: null,
};
const AuthContext = createContext({
  ...initialState,
  setLoggedInUser: (user) => {},
  setActiveCompany: (company) => {},
});
export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [activeCompany, setActiveCompany] = React.useState(null);
  const setLoggedInUser = (newUser) => {
    setUser(newUser);
  };

  async function refreshUser() {
    try {
      await Auth.currentSession();
      let userResponse = await Auth.currentAuthenticatedUser();
      let o = await get(Constants.dbTypes.USER, userResponse.username);
      setLoggedInUser(o);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        activeCompany,
        setLoggedInUser,
        setActiveCompany,
        refreshUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
